import ATE from "../../../ActionTypeEnum";

export default {

    submitInput: () => ({
        type: ATE.SUBMIT_INPUT,
    }),

    testMessage: () => ({
        type: ATE.TEST_MESSAGE,
    }),

    sequenceFromID: (sequence: String) => ({
        type:ATE.SEQUENCE_FROM_ID,
        value: sequence,
    }),

    jobConfiguration: () => ({
        type: ATE.JOB_CONFIGURATION,
    }),

    newJobRequest: () => ({
        type: ATE.SUMMARY_NEW_JOB_REQUEST,
    }),

    newJobFailure: () => ({
        type: ATE.SUMMARY_NEW_JOB_FAILURE,
    }),

    newJobSuccess: (jobId: string) => ({
        type: ATE.SUMMARY_NEW_JOB_SUCCESS,
        value: jobId,
    }),

}
